/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import {
    CellHeader,
    CellBody,
    CellsTitle,
    Form,
    FormCell,
    Input,
    Label,
    CellFooter
} from 'react-weui';

const mustStyle = { fontSize: '14px' }

const fixPadding = { fontSize: '14px', width: '100px' }

class ComplainContact extends Component {
    constructor() {
        super();
        this.handleMobileChange = this.handleMobileChange.bind(this);
        this.handleWechatNoChange = this.handleWechatNoChange.bind(this);
        this.getData = this.getData.bind(this);

        this.state = {
            mobile: '',
            wechatNo: ''
        }
    }

    handleMobileChange(e) {
        this.setState({mobile: e.target.value});
    }

    handleWechatNoChange(e) {
        this.setState({wechatNo: e.target.value});
    }

    getData() {
        const {mobile, wechatNo} = this.state;
        return {mobile, wechat_no: wechatNo};
    }

    render() {
        return (
            <div className="complain-contact">
                <CellsTitle>请填写你的个人信息，方便我们联系你：</CellsTitle>

                <Form>
                    <FormCell>
                        <CellHeader>
                            <Label>手机号</Label>
                        </CellHeader>
                        <CellBody>
                            <Input 
                                type="tel" 
                                placeholder={this.props.isFromQuestion ? '必填' : '手机号与微信选填一个'} 
                                onChange={this.handleMobileChange}
                            />
                        </CellBody>
                        <CellFooter>
                          <Label style={mustStyle}>*</Label>
                        </CellFooter>
                    </FormCell>
                    <FormCell>
                        <CellHeader>
                            <Label>微信号</Label>
                        </CellHeader>
                        <CellBody>
                            <Input type="text" placeholder="手机号与微信选填一个" onChange={this.handleWechatNoChange}/>
                        </CellBody>
                        <CellFooter>
                          <Label style={fixPadding}>*</Label>
                        </CellFooter>
                    </FormCell>
                </Form>
            </div>
        )
    }
}

export default ComplainContact


// WEBPACK FOOTER //
// ./src/components/complain/ComplainContact.js